<div class="card card-wider card-cascade">
  <div class="view gradient-card-header primary-gradient white-text">
      <h3 class='h3-responsive text-center'>{{title}}</h3>
  </div>
  <div class="card-body">
      <div *ngIf="description" [innerHTML]="description"></div>
      <p *ngIf="!hasFocusQuestions" class="h4 text-center">There were no flagged items of concern to address.</p>
      <app-scale-questions-list *ngIf="hasFocusQuestions" [Questions]="FlaggedQuestions" [flagPrompts]="true" [displayScale]="true"></app-scale-questions-list>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/reports/report-items/flagged-questions-list-simple/flagged-questions-list-simple.component.html